/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EntranceGuidRedirectPageQueryVariables = Exact<{ [key: string]: never; }>;


export type EntranceGuidRedirectPageQuery = { entrances: Array<{ guid: string }> };


export const EntranceGuidRedirectPageDocument = gql`
    query EntranceGUIDRedirectPage {
  entrances {
    guid
  }
}
    `;

/**
 * __useEntranceGuidRedirectPageQuery__
 *
 * To run a query within a Vue component, call `useEntranceGuidRedirectPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntranceGuidRedirectPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEntranceGuidRedirectPageQuery();
 */
export function useEntranceGuidRedirectPageQuery(options: VueApolloComposable.UseQueryOptions<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>(EntranceGuidRedirectPageDocument, {}, options);
}
export function useEntranceGuidRedirectPageLazyQuery(options: VueApolloComposable.UseQueryOptions<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>(EntranceGuidRedirectPageDocument, {}, options);
}
export type EntranceGuidRedirectPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EntranceGuidRedirectPageQuery, EntranceGuidRedirectPageQueryVariables>;